import { Modal as ModalModule, UI, Utils } from 'common';
import isFunction from 'lodash/isFunction';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import ContactsCommunication from '../utils/ContactsCommunication';

const { Modal, ModalButtonActionType } = ModalModule;
const { WrappedInputTextWithLabel } = UI;
const { withLayoutAndModalContexts } = Utils;

const AddEditGroupModal = ({
	modalId,
	data: { groups, action, selectedGroup, manageGroupsUpdateCallback },
	modalContext: { showError, closeModal },
	layoutContext: { isMobile },
}) => {
	const [groupName, setGroupName] = useState(
		action === 'Add' ? '' : selectedGroup.name
	);
	const [groupNameError, setGroupNameError] = useState(false);
	const [isClean, setIsClean] = useState(true);
	const mobileClassName = isMobile ? 'mobile-wrapper' : '';

	const onInputTextChange = ({ target: { value } }) => {
		setIsClean(false);
		setGroupName(value);
	};

	const onInputTextBlur = ({ target: { value } }) => {
		if (value === '') {
			setGroupNameError(true);
			return;
		}

		// check for duplicate name
		const allGroupNames = [];

		groups.forEach(group => {
			allGroupNames.push(group.name.toLowerCase());
		});

		if (allGroupNames.includes(groupName.toLowerCase())) {
			setGroupNameError(true);
			return;
		}
		setGroupNameError(false);
	};

	const onPrimaryButtonClick = async () => {
		let response;

		if (action === 'Add') {
			response = await ContactsCommunication.addGroup({
				name: groupName,
			});
		} else {
			response = await ContactsCommunication.renameGroup({
				id: selectedGroup.id,
				name: groupName,
			});
		}

		if (ContactsCommunication.isSuccessful(response)) {
			setIsClean(true);

			// callback from ManageGroup to set new/updated group name
			if (isFunction(manageGroupsUpdateCallback)) {
				manageGroupsUpdateCallback(action, response.data);
			}

			closeModal(modalId, ModalButtonActionType.Ok, true);
		} else {
			showError({ response });
		}
	};

	const primaryButton = {
		type: ModalButtonActionType.Ok,
		text: 'Save',
		disabled: isClean || groupNameError,
		onClick: onPrimaryButtonClick,
		dataqa: 'add-edit-group-save-button',
	};

	return (
		<Modal
			modalId={modalId}
			className="contacts contacts-add-edit-group-modal"
			header={`${action === 'Add' ? 'Add Group' : 'Edit Group'}`}
			primaryButton={primaryButton}
			size="small"
		>
			<WrappedInputTextWithLabel
				className={`inputtext ${mobileClassName}`}
				showErrorBelow={isMobile}
				isInputInvalid={groupNameError}
				errorMessage={`${
					groupName === ''
						? 'Group name is required.'
						: 'Group name already exists'
				}`}
				label="Group Name:"
				uiElementConfig={{
					type: 'text',
					value: groupName,
					name: 'groupName',
					dataqa: 'groupname',
					maxLength: 20,
					onChange: onInputTextChange,
					onBlur: onInputTextBlur,
				}}
			/>
		</Modal>
	);
};

AddEditGroupModal.propTypes = {
	data: PropTypes.shape({
		action: PropTypes.oneOf(['Add', 'Edit']),
	}),
};

export default withLayoutAndModalContexts(AddEditGroupModal);
